export default "__VITE_ASSET__BNGHWnYj__"